/* eslint-disable no-unused-vars,react/prop-types */
// noinspection JSUnusedLocalSymbols,JSUnresolvedVariable

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {cloneDeep, concat, find, get, includes, isEqual, lowerCase, map, merge, omit, replace, set} from 'lodash';

import DropDownMenu from '../c_DropDownMenu';

import RaisedButton from 'material-ui/RaisedButton';
import DeleteIcon from '../../svgs/DeleteIcon';
import SearchIcon from '../../svgs/SearchIcon';
import EditJobIcon from '../../svgs/EditJobIcon';
import CloneIcon from '../../svgs/CloneIcon';
import ChevronIcon from '../../../common/svgs/ChevronIcon';
import InfoIcon from '../../../common/svgs/InfoIcon';

import {getLookupValue, lookup} from '../../../redux/helpers/staticData';
import moment from 'moment';
import cx from 'classnames';

import * as jobRequestStore from '../../../redux/actionCreators/sync/jobrequests';
import * as jobRequestApi from '../../../redux/actionCreators/async/jobrequests';
import * as jobRequestDocumentsStore from '../../../redux/actionCreators/sync/jobrequestDocuments';
import * as jobRequestDocumentsApi from '../../../redux/actionCreators/async/jobrequestDocuments';
import * as ui from '../../../redux/actionCreators/sync/ui';

import Pager from 'rc-pager';
import RouteTransitionBlocker from '../../../react/r_ApplicantDashboard/f_RouteTransitionBlocker';
import PreviousIcon from '../../../common/svgs/PreviousIcon';
import NextIcon from '../../../common/svgs/NextIcon';
import {parentChildList} from '../../../lib/parentChildList';

import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import InfoModal from '../f_InfoModal';
import prettyPhone from '../../../lib/prettyPhone';

// noinspection JSCheckFunctionSignatures
@connect((store) => {
  const staticData = store.staticData;
  const pathname = store.routing.locationBeforeTransitions.pathname;
  return {
    staticData,
    pathname,
    labels: get(store, 'labels.JobRequestDashboard.jobRequestTable', {}),
    bqpMigrationFeature: store.staticData.featureToggles.find(feature => feature.hardcodelink === 'BQP_MIGRATION_FEATURE').value === true,
    bqpClientMigrationLabels    : store.labels.Client.BqpClientMigration,
    contact: store.contactProfile,
    employeeMode: store.user.roles.indexOf('Client') === -1
  };
})
export default class JobRequestTable extends Component {

  static propTypes = {
		dispatch : PropTypes.func.isRequired,
    jobRequests: PropTypes.object,
    jobRequestsList: PropTypes.array,
    contacts: PropTypes.array,
		staticData: PropTypes.object,
    showHeader: PropTypes.bool,
    showSearch: PropTypes.bool,
    showFilters: PropTypes.bool,
    companyId: PropTypes.number,
    showContactFilter: PropTypes.bool,
    onJobRequestFilterChange: PropTypes.func,
    onJobRequestTermsChange: PropTypes.func,
    fetchJobs: PropTypes.func,
    columns: PropTypes.array,
    disableEditButton: PropTypes.func,
    linksInNewTab: PropTypes.bool,
    tableHeight: PropTypes.string,
    filters: PropTypes.object,
    searchTerms: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    labels: PropTypes.object,
    bqpMigrationFeature: PropTypes.bool,
    showBqpMigrationModal: PropTypes.bool,
    bqpClientMigrationLabels: PropTypes.object.isRequired,
    contact: PropTypes.object.isRequired,
    employeeMode: PropTypes.bool
	}

  constructor(props, context) {
    super(props, context);
    this.onChangeSearch = ::this.onChangeSearch;
    this.onChangeFilter = ::this.onChangeFilter;
    this.handleSkip = ::this.handleSkip;
    this.fetchJobRequests = ::this.fetchJobRequests;
    this.renderCityState = ::this.renderCityState;

    this.getFilterAttributes = ::this.getFilterAttributes;

    this.parentChildHandlers = parentChildList();

  }

  state = {
    showHeader: get(this.props, 'showHeader', true),
    showSearch: get(this.props, 'showSearch', true),
    showFilters: get(this.props, 'showFilters', true),
    showContactFilter: get(this.props, 'showContactFilter', true),
    columns: this.props.columns !== undefined ? this.props.columns : [
      'Id',
      'DateCreated',
      'DateSubmitted',
      'Title',
      'Openings',
      'Contact',
      'Status',
      'Buttons'
    ],
    sortBy: {
      field: 'dateCreated',
      order: 'desc'
    },

    // jobRequestsList: get(this.props, 'jobRequestsList', []),
    placementSpecialists: this.props.staticData.placementSpecialists,
    filters: {},
    terms: [],
    pageSize: 25,
    currentPage: 0,
    hasPagination: includes(this.props, '/admin/jobrequests'), // include pagination just for 'admin/jobrequests' for now
    showBqpMigrationModal: false,
  };

  componentDidMount() {
    // fetch all jobRequests if we don't have them
    this.fetchJobRequests(this.props.searchTerms || [], this.props.filters || {});
  }

  componentDidUpdate(prevProps) {
    const oldFilters = prevProps.filters;
    const oldTerms = prevProps.searchTerms;

    // only fetch if filters or search terms have changed

    if (!isEqual(oldFilters, this.props.filters) || !isEqual(oldTerms, this.props.searchTerms)) {
      this.fetchJobRequests(this.props.searchTerms, this.props.filters, this.state.currentPage * this.state.pageSize);
    }
  }

  onChangeFilter(filterName) {
    return (event, key) => {
      let newFilters = cloneDeep(this.props.filters) || {};

      if (key < 0 || key === undefined) {
        newFilters = omit(newFilters, filterName);
      }else {
        set(newFilters, filterName, key);
      }

      if (this.props.onJobRequestFilterChange) { this.props.onJobRequestFilterChange(newFilters); }

      this.setState({...this.state, currentPage: 0});
    };
  }

  onChangeSearch(event) {
      // noinspection JSCheckFunctionSignatures
    const value = event.target.value ? String(event.target.value) : null;
      this.setState({currentPage: 0 }, () => {
        this.props.onJobRequestTermsChange(value || []);
      });
  }

  getFilterAttributes = (fieldName, label, listName, menuItems) => {
    return {
      onChange: this.onChangeFilter(fieldName),
      floatingLabelText: label,
      key: `${fieldName} ${get(this.props.filters, fieldName, -1)}`,
      value: get(this.props.filters, fieldName, -1),
      className: 'dropdown-filter',
      menuItems: menuItems ? menuItems : this.generateMenuItems(this.props.staticData, listName),
    };
  }

  getJobLink = (id) => {

     if (includes(this.props.pathname, 'admin')) {
       return `/admin/jobrequests/${id}`;
     } else if (includes(this.props.pathname, 'client')) {
       return `/client/jobrequest/${id}/confirmation`;
     }

  }

  getContact(primaryContactId) {
    const contact = find(this.props.contacts, (c) => {
      return c.profile.id === primaryContactId;
    });

    if (contact) {
      return contact;
    }
  }

  cloneDisabled = (jobRequest) => {
    const DNC = this.props.staticData.companyStatus.find(status => status.name === 'DNC');
    return (
      (this.getContact(jobRequest.primaryContactId).company.companyStatus === DNC.id)
    ) ?  'disabled' : '';
  }

  disableEditButton = (jobRequest) => {

    if(this.props.disableEditButton) {
      return this.props.disableEditButton(jobRequest);
    }

    return false;
  }

  loadJob(id) {

    const path = this.getJobLink(id);

    return (event) => {
      this.props.dispatch(ui.showSpinner());
      this.props.dispatch(push(path));
    };
  }

  doDelete = () => {
    const deleteJobRequest = (jobId) => this.props.dispatch(jobRequestApi.deleteJobRequest(jobId));
    deleteJobRequest(this.state.deleteId)
      .then(() => {
        this.fetchJobRequests(this.props.searchTerms, this.props.filters);
        this.setState({showTransitionBlocker: false, deleteId: null});
      });
  }

  handleDelete(row) {
    return () => {
      if (row.jobRequestStatus === 1) {
        this.setState({showTransitionBlocker: true, deleteId: row.id});
      }
    };
  }

  handleEditJob(row) {
    return (event) => {
      if ((!this.props.bqpMigrationFeature) || this.props.employeeMode) {    // save the fact that we've shown the migration modal in this session
        if (row.jobRequestStatus <= 2) {
          this.props.dispatch(push(`/client/jobrequest/${row.id}`));
        }
      }

      // eslint-disable-next-line no-else-return
      else
      {
        this.setState({...this.state, showBqpMigrationModal: true});
      }
    };
  }

  handleClone(row) {
    return () => {
      if ((!this.props.bqpMigrationFeature) || this.props.employeeMode) {    // save the fact that we've shown the migration modal in this session
        const getDocuments = (primaryContactId, jobId) => this.props.dispatch(jobRequestDocumentsApi.getJobRequestDocuments(primaryContactId, jobId));

        getDocuments(row.primaryContactId, row.id)
          .then((documents) => {

            // Move JobRequest and documents to store.

            this.props.dispatch(jobRequestDocumentsStore.updateJobRequestDocuments(documents));
            this.props.dispatch(jobRequestStore.updateJobRequest(row));

            this.props.dispatch(push('/client/jobrequest?clone'));

          });
      }

      // eslint-disable-next-line no-else-return
      else
      {
        this.setState({...this.state, showBqpMigrationModal: true});
      }
    };
  }

  handleSkip(page) {
    this.setState({ currentPage: page});
    this.fetchJobRequests(
      this.props.searchTerms,
      this.props.filters,
      (page * this.state.pageSize)
    );
  }

  employeesToMenuItems(employees = []) {
    const menuItems = employees.map((employee) => {
      return {
        primaryText: `${employee.firstName} ${employee.lastName}`,
        value: employee.employeeId,
      };
    });

    return concat({value: -1, primaryText: 'All'}, menuItems);
  }

  // noinspection JSUnusedGlobalSymbols
  contactsToMenuItems(contacts) {
    const menuItems = map(contacts, (contact) => {
      return {
        value: contact.profile.id,
        primaryText: `${contact.user.firstName} ${contact.user.lastName}`
      };
    });

    return concat({value: -1, primaryText: 'All'}, menuItems);
  }

  generateMenuItems(staticData, type) {
    const object = staticData[type];

    const menuItems = map(object, (item) => {
      return {
        value: item.id || item.value,
        primaryText: (item.name || item.primaryText),
        parentId: item.parentId
      };
    });

    return concat({value: -1, primaryText: 'All'}, menuItems);
  }

  fetchJobRequests(terms = [], filters = {}, skip) {
    filters.order = filters.order || this.state.sortBy.order;
    filters.by = filters.by || this.state.sortBy.field;
    if (this.props.fetchJobs) this.props.fetchJobs(filters, terms, skip);
  }

  flipColumn(column) {
    const order = this.props.filters.by === column && this.props.filters.order === 'desc' ? 'asc' : 'desc';
    const newFilters = merge({}, cloneDeep(this.props.filters), {order, by: column});

    if (this.props.onJobRequestFilterChange) { this.props.onJobRequestFilterChange(newFilters); }
  }

  // Render functions for each column

  // noinspection JSUnusedGlobalSymbols
  renderId(header, row, index) {
    return this.renderIdWithLink(header, row, index, true);
  }

  // noinspection JSUnusedGlobalSymbols
  renderIdNoLink(header, row, index) {
    return this.renderIdWithLink(header, row, index, false);
  }

  renderIdWithLink(header, row, index, showLink) {
    if (header) {
      return this.renderHeader('Job #', 'job-number', 'id', true);
    }

    return (<TableRowColumn data-id={`Job Number${index}`} className='job-number'>
      { showLink  && !this.props.linksInNewTab
        &&
        <div className='text-link' onClick={this.loadJob(row.id)}>{row.id}</div>
      }

      { showLink && this.props.linksInNewTab
        &&
        <a className='text-link' target='_blank' href={this.getJobLink(row.id)}>{row.id}</a>
      }

      {
        !showLink &&
          <div>{row.id}</div>
      }
    </TableRowColumn>);
  }

  // noinspection JSUnusedGlobalSymbols
  renderDate(header, row, index) {
// Handle legacy use of 'Date' instead of specifying 'DateCreated' or 'DateSubmitted'
    return this.renderDateCreated(header, row, index);
  }

  renderDateCreated(header, row, index) {
    if (header) {
      return this.renderHeader('Date Added', 'date-added', 'dateCreated', true);
    }

    return (<TableRowColumn data-id={`Date Added${index}`} className='date-added'>
      {moment(row.dateCreated).format('L')}
    </TableRowColumn>);
  }

  // noinspection JSUnusedGlobalSymbols
  renderDateSubmitted(header, row, index) {
    if (header) {
      return this.renderHeader('Date Submitted', 'date-authorized', 'dateAuthorized', true);
    }

    return (<TableRowColumn data-id={`Date Submitted${index}`} className='date-authorized'>
      {(row.dateAuthorized !== null) ? moment(row.dateAuthorized).format('L') : ''}
    </TableRowColumn>);
  }

  // noinspection JSUnusedGlobalSymbols
  renderTitle(header, row, index) {
    if (header) {
      return this.renderHeader('Job Title', 'job-title', 'positionTypeId', true, 2);
    }

    return (<TableRowColumn colSpan={2} key={`Job Title${index}`} data-id={`Job Title${index}`} className='job-title'>
      {lookup(this.props.staticData, 'positionTypes', {id: row.positionTypeId})}
    </TableRowColumn>);
  }

  // noinspection JSUnusedGlobalSymbols
  renderOpenings(header, row, index) {
    if (header) {
      return this.renderHeader('Openings');
    }

    return (<TableRowColumn key={`Openings${index}`} data-id={`Openings${index}`} className='openings'>
      {row.numberOfPeople}
    </TableRowColumn>);
  }

  // noinspection JSUnusedGlobalSymbols
  renderContact(header, row, index) {
    if (header) {
      return this.renderHeader('Contact');
    }

    return (<TableRowColumn key={`Contact${index}`} data-id={`Contact${index}`} className='contact'>
      {row.primaryContact
        &&
        <span>{row.primaryContact}</span>
      }
    </TableRowColumn>);
  }

  // noinspection JSUnusedGlobalSymbols
  renderCompany(header, row, index) {
    if (header) {
      return this.renderHeader('Company', 'company-name');
    }

    return (<TableRowColumn key={`Contact${index}`} data-id={`Contact${index}`} className='contact'>
      {row.companyName
        &&
        <span>{row.companyName}</span>
      }
    </TableRowColumn>);
  }

  // noinspection JSUnusedGlobalSymbols
  renderStatus(header, row, index, status) {
    if (header) {
      return this.renderHeader('Status', 'status', 'jobRequestStatus', true);
    }

    return (<TableRowColumn key={`Status #${index}`} data-id={`Status #${index}`} className='status'>
      <div className='status-circle' data-id='Status Icon' style={{backgroundColor: status.color, borderColor: status.color}}></div>{status.name}
    </TableRowColumn>);
  }

  renderHeader(headerText, className, columnName = undefined, isSortable = false, colspan = 1) {
    if (!className) {
      className = replace(lowerCase(headerText), ' ', '-');
    }
    return (
      <TableHeaderColumn colSpan={colspan} className={cx(className, {'wv-pointer': isSortable})}>
        <div onClick={isSortable ? (e) => this.flipColumn(columnName) : ''}>
          {headerText}
          {isSortable
            &&
            <span className={cx('wv-chevron',
              {active: this.props.filters && this.props.filters.by === columnName},
              {flipped: this.props.filters && this.props.filters.by === columnName && this.props.filters.order !== 'desc'})} >
              <ChevronIcon/>
            </span>
          }
        </div>
      </TableHeaderColumn>
    );
  }

  // noinspection JSUnusedGlobalSymbols
  renderActions(header, row, index, status) {

    if (header) {
      return this.renderHeader('Actions', 'actions', undefined, false, 3);
    }

    const disabled = this.disableEditButton(row) || status.id > 2;
    const disableClone = this.cloneDisabled(row);
    const disableDelete = (status.id > 1 || (this.props.bqpMigrationFeature && (!this.props.employeeMode))) ? 'disabled' : '';

    // overflow visible hack for tooltips in TableRowColumn
    return (<TableRowColumn colSpan={3} key={`Actions ${index}`} data-id={`Actions ${index}`} className='actions' style={{overflow: 'visible'}}>
      <RaisedButton label='View'
                    labelStyle={{textTransform: 'None'}}
                    icon={<InfoIcon className='action-button'/>}
                    variant='outlined'
                    className='action-button'
                    tooltip='View'
                    tooltipPosition={'bottom-center'}
                    target='_blank'
                    href={this.getJobLink(row.id)}
    />

      <RaisedButton label='Edit'
                    labelStyle={{textTransform: 'None'}}
                    icon={<EditJobIcon className='action-button' />}
                    variant='outlined'
                    data-id={`Edit${index}`}
                    className={cx('action-button', {disabled})}
                    tooltip='Edit'
                    tooltipPosition={'bottom-center'}
                    onClick={this.handleEditJob(row) }
                    primary={false}

    />

      <RaisedButton label='Clone'
                    labelStyle={{textTransform: 'None'}}
                    icon={<CloneIcon className='action-button' />}
                    variant='outlined'
                    data-id={`Clone${index}`}
                    className={cx('action-button', disableClone)}
                    tooltip='Copy'
                    tooltipPosition={'bottom-center'}
                    onClick={this.handleClone(row)}
                    primary={false}
    />
    <RaisedButton label='Delete'
                  labelStyle={{textTransform: 'None'}}
                  icon={<DeleteIcon className='action-button' />}
                  variant='outlined'
                  data-id={`Delete${index}`}
                  className={cx('action-button', disableDelete)}
                  tooltip='Delete'
                  tooltipPosition={'bottom-center'}
                  onClick={this.handleDelete(row)}
                  primary={false}
    />
    </TableRowColumn>);
  }

  renderCityState(header, row, index, status) {
    if (header) {
      return this.renderHeader('City & State', 'city-state');
    }

    const state = find(this.props.staticData.stateList, (s) => s.id === (row.state ? row.state : row.companyState));
    return (<TableRowColumn key={`CityState${index}`} data-id={`CityState${index}`} className='city-state'>
      {row.city ? `${row.city}, ` : row.companyCity ? `${row.companyCity}, ` : ''} {state ? state.abbreviation : ''}
    </TableRowColumn>);
  }

  // noinspection JSUnusedGlobalSymbols
  renderFirm(header, row, index, status) {
    if (header) {
      return this.renderHeader(this.props.labels.tableRowHeaders.firmType);
    }

    return (<TableRowColumn key={`Firm${index}`} data-id={`Firm${index}`} className='firm-type'>
      {lookup(this.props.staticData, 'industryTypesList', {id: row.industryTypeId})}
    </TableRowColumn>);
  }

  // noinspection JSUnusedGlobalSymbols
  renderIndustry(header, row, index, status) {
    if (header) {
      return this.renderHeader('Industry Segment');
    }

    return (<TableRowColumn key={`Segment${index}`} data-id={`Segment${index}`} className='industry-segment'>
      {lookup(this.props.staticData, 'jobRequestSegmentTypes', {id: row.segmentTypeId})}
    </TableRowColumn>);
  }
  // save the fact that we've shown the migration modal in this session
  closeModal() {
    this.setState(merge(this.state, {showBqpMigrationModal: false}));
  }
  render() {

    let company, clientAdviser, relationshipManager;
    let migrationText, migrationModalEmailLink, migrationOtherContacts;

    if (this.props.bqpMigrationFeature && (!this.props.employeeMode)) {
      company = this.props.contact.company;
      clientAdviser = this.props.staticData.clientAdvisers && this.props.staticData.clientAdvisers.find((ca) => {
        return company.clientAdvisorId === ca.employeeId;
      });
      relationshipManager = this.props.staticData.relationshipManagers && this.props.staticData.relationshipManagers.find((ca) => {
        return company.relationshipManagerId === ca.employeeId;
      });

      migrationText = this.props.bqpClientMigrationLabels.message;
      migrationModalEmailLink = <div className='migration-modal-font-color'><br/><a href='mailto:sales@wahve.com'>{this.props.bqpClientMigrationLabels.emailLinkText}</a></div>;
      migrationOtherContacts = (
        (clientAdviser || relationshipManager) &&
          <div>
            <br/><br/>
            If you prefer, you can also reach out to one of your WAHVE team members.
            <br/><br/>
            {clientAdviser &&
              <div>Client Advisor:
                <span>{` ${clientAdviser.firstName} ${clientAdviser.lastName}`}, • </span>
                <span className='migration-modal-font-color'>
                {clientAdviser.phoneNumber && (`${prettyPhone(clientAdviser.phoneNumber)} • `)}
                  <a href={`mailto:${clientAdviser.email}`}>{clientAdviser.email}</a>
                </span>
              </div>
            }
            {relationshipManager &&
              <div>Relationship Manager:
                <span>{` ${relationshipManager.firstName} ${relationshipManager.lastName}`}, • </span>
                <span className='migration-modal-font-color'>
                {relationshipManager.phoneNumber && (`${prettyPhone(relationshipManager.phoneNumber)} • `)}
                  <a href={`mailto:${relationshipManager.email}`}>{relationshipManager.email}</a>
              </span>
              </div>
            }
          </div>
      );
    }

    const jobs = get(this.props, 'jobRequestsList', []);

    let total = jobs.length > 0 ? jobs[0].total_count : 0;
    let currentCount = this.state.pageSize * (this.state.currentPage + 1);
    currentCount = (currentCount < total) ? currentCount : total;

    const {parent: industryTypeProps, child: segmentTypeProps} = this.parentChildHandlers({
      parentProps: this.getFilterAttributes('industryTypeId', this.props.labels.filterLabels.firmTypesFilter, 'industryTypesList'),
      childProps: this.getFilterAttributes('segmentTypeId', 'Industry Segment',  'jobRequestSegmentTypes'),
   });


    return (
        <div className='job-request-table info-table'>
        {this.state.showSearch
          &&
          <header className='job-request-history-header'>
            {this.state.showHeader
              &&
              <div className='job-request-history-title-container'>
                <h1 className='job-request-history-title'>JOB REQUESTS</h1>
              </div>
            }
            <div className='job-request-history-search-container'>
              <div className='job-request-history-search'>
                <SearchIcon />
                <input onChange={ (event) => this.onChangeSearch(event) }
                  data-id='Search'
                  ref='search'
                  className='search-input'
                  type='text'
                  placeholder='Search by ID...'
                  value={this.props.searchTerms || ''}/>
              </div>
            </div>
          </header>
        }


        {this.state.showFilters
          &&
          <div className='job-request-history-filter'>
              <DropDownMenu
                data-id='status-dropdown'
                {...this.getFilterAttributes('jobRequestStatus', 'Status', 'jobRequestStatus')}
              />
              <DropDownMenu
                data-id='industry-dropdown'
                {...industryTypeProps}
              />
              <DropDownMenu
                data-id='segment-dropdown'
                {...segmentTypeProps}
              />

              <DropDownMenu
                data-id='placement-specialist-dropdown'
                {...this.getFilterAttributes('placementSpecialistId', 'Placement Specialist', 'placementSpecialists', this.employeesToMenuItems(this.state.placementSpecialists))}
              />
          </div>
          }

          {
            this.state.hasPagination &&
            <div className='pager-wrapper'>
              <div className='pager-info'>Showing <span className='count'>{currentCount}</span> of <span className='count'>{total}</span></div>
              <Pager
                total={Math.ceil(total / this.state.pageSize)}
                current={this.state.currentPage}
                onSkipTo={this.handleSkip}
                previousLabel={<div className='prev'><PreviousIcon/>PREV</div>}
                nextLabel={<div className='next'>NEXT<NextIcon/></div>}
              />
            </div>
          }

        <div className='job-request-history-table'>
          <Table selectable={false}
            multiSelectable={false}
            fixedHeader
            height={this.props.tableHeight || 'calc(100vh - 295px)'}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                {map(this.state.columns, (column) => {
                  return this[`render${column}`](true);
                })}
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {jobs.length === 0
                &&
                <div className='table-no-data'>No Job Requests Available</div>
              }
                {map(jobs, (row, index) => {
                  const status = getLookupValue(this.props.staticData, 'jobRequestStatus', {id: row.jobRequestStatus});
                  return (<TableRow key={`${row.id}`} data-id={`Contact ${row.id}`}>
                      {map(this.state.columns, (column) => {
                        return this[`render${column}`](false, row, index, status);
                      })}
                    </TableRow>);
                })
              }
            </TableBody>
          </Table>
        </div>

        {
          this.state.showTransitionBlocker
          &&
          <RouteTransitionBlocker
            secondaryAction={this.doDelete}
            secondaryButtonLabel='Delete'
            cancelAction={() => this.setState({showTransitionBlocker: false, deleteId: null})}
            primaryAction={() => this.setState({showTransitionBlocker: false, deleteId: null})}
            primaryButtonLabel='Cancel'
            transitionText={'Are you sure you want to delete this job request?'}
          />
        }
        { // show migration modal?
          this.props.bqpMigrationFeature &&
          this.state.showBqpMigrationModal &&
          (!this.props.employeeMode) &&
          <div className='migration-modal-font-color'>
            <InfoModal
              buttonLabel={'close'}
              text={migrationText}
              children= {[migrationModalEmailLink, migrationOtherContacts]}
              cancelFunc={this.closeModal.bind(this)}
              transitionFunc={this.closeModal.bind(this)}
            />
          </div>
        }
      </div>
    );

  }
}



// WEBPACK FOOTER //
// ./shared/common/components/JobRequestTable/index.js